import { useEffect, useRef, useContext, useState, Fragment } from 'react';
import './Main.css';
import MainNavigationDotItem from './MainNavigationDotItem';
import MainNavigationItem from './MainNavigationItem';

import * as THREE from 'three';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls';
import gsap from 'gsap';

import { mapRange, invokeAfterDelay } from './three/Common';
import { scene, group, SetupScene } from './three/Scene';
import { setupRenderer, Update, ResizeScreen, GetIsMobileDevice } from './three/Renderer';
import { SetupLights } from './three/Light';
// import { CameraContext } from './CameraContext';
import { cameraState, SetupCamera, AnimateCamera, GetCameraInfo, setMoveToCamera } from './three/Camera';
import { setLoadingManager, SetLoading } from './three/LoadingManager';

import { loadModel, RotateModelOnMouseMove, BoxMesh } from './three/Model';
import { UpdateMixers, SetAnimations } from './three/Animations';
import { UpdateRaycaster, SetStageRaycastList, onMouseDown, onMouseMove, onMouseUp } from './three/Raycaster';
import { SetStep, SetStepChangeListener, InitScenario, SetBalloonRef, MoveCrosshair, SetCloudContainer, ShowTooltip, SetNavigationStateRef } from './three/ScenarioManager';
import { SetAudioListener, InitAudio, SetMute } from './three/Audio';


const Main = ({ lang, setIsModelLoaded,
    isMute, setMute,
    isOpenAnimComplete, setIsOpenAnimComplete,
    isOverlayContentVisible,
    setCoinScreenPos,
    scenarioStep, setScenarioStep,
    isStart, ScenarioStart, ScenarioStop }) => {
    // const { setCameraActions } = useContext(CameraContext);


    // HTML element refs
    const canvasRef = useRef(null);
    const blurRef = useRef(null);
    const loadingRef = useRef(null);
    const loadingRateRef = useRef(null);
    const loadingAnimationLoopRef = useRef(null);

    const balloonRef = useRef(null);
    const balloonDimRef = useRef(null);
    const balloonCrosshairBgRef = useRef(null);
    const balloonCrosshairRef = useRef(null);
    const cloundContainerRef = useRef(null);

    let sizes;
    let renderer, camera, light, loadingManager;
    let gltf, obj;

    let coin;
    let objet; // 최종 개체

    const clock = new THREE.Clock();


    let listener;

    ///exr loader
    let pmremGenerator;

    let mouseX, mouseY;

    useEffect(() => {
        Init();

        // console.log("Main use effect");
        SetBalloonRef(balloonRef, balloonDimRef, balloonCrosshairBgRef, balloonCrosshairRef);
        SetCloudContainer(cloundContainerRef);
        // setCameraActions(prev => ({
        //     ...prev,
        //     setMoveToCamera
        // }));
        // const handleCloseSubToMain = () => {
        //     if (cameraState !== "main") {
        //         setMoveToCamera("main"); // 카메라 홈으로 이동
        //         console.log('to main');
        //     }
        // };
        const handleResize = () => ResizeScreen(renderer, sizes, camera);
        const handleMouseMoveModel = (e) => RotateModelOnMouseMove(e, group, mapRange);
        const handleMouseDown = (e) => onMouseDown(e, scene, camera, canvasRef, ScenarioStart);
        const handleMouseMove = (e) => onMouseMove(e, scene, camera, canvasRef);
        const handleMouseUp = (e) => onMouseUp(e, scene, camera, canvasRef, ScenarioStart, ScenarioStop);

        // const handleMouseClick = (e) => GetCameraInfo(scene, camera, controlsRef.current);

        const muteToggle = document.querySelector('.nav-sound-mute');

        const FirstDownAudioSettings = () => {
            setMute(false);
            muteToggle.style.textDecoration = 'none';
            SetAudioListener();
            InitAudio();
            canvasRef.current.removeEventListener('mousedown', FirstDownAudioSettings);
            muteToggle.removeEventListener('mousedown', FirstDownAudioSettings);
        }

        const cursorMove = (e) => {
            mouseX = (e.clientX / window.innerWidth) * 2 - 1;
            mouseY = -(e.clientY / window.innerHeight) * 2 + 1;
        }

        // window.addEventListener('closeSubToMain', handleCloseSubToMain);
        window.addEventListener('resize', handleResize);
        window.addEventListener('mousemove', handleMouseMoveModel);
        canvasRef.current.addEventListener('mousedown', handleMouseDown);
        canvasRef.current.addEventListener('mousemove', handleMouseMove);
        canvasRef.current.addEventListener('mouseup', handleMouseUp);
        // canvasRef.current.addEventListener('click', handleMouseClick);
        window.addEventListener('mousemove', MoveCrosshair);


        //* 마우스 커서 위치 추적
        window.addEventListener('mousemove', cursorMove);

        //* audio
        canvasRef.current.addEventListener('mousedown', FirstDownAudioSettings);
        muteToggle.addEventListener('mousedown', FirstDownAudioSettings);

        return () => {
            // window.removeEventListener('closeSubToMain', handleCloseSubToMain);
            window.removeEventListener('resize', handleResize);
            window.removeEventListener('mousemove', handleMouseMoveModel);
            canvasRef.current.removeEventListener('mousedown', handleMouseDown);
            canvasRef.current.removeEventListener('mousemove', handleMouseMove);
            canvasRef.current.removeEventListener('mouseup', handleMouseUp);
            // canvasRef.current.removeEventListener('click', handleMouseClick);

            window.removeEventListener('mousemove', MoveCrosshair);

            window.removeEventListener('mousemove', cursorMove);

            canvasRef.current.removeEventListener('mousedown', FirstDownAudioSettings);
            muteToggle.removeEventListener('mousedown', FirstDownAudioSettings);

            console.log("Main use effect return");
        }
    }, []);

    useEffect(() => {
        if (!isStart) {
            if (scenarioStep === 21) {
                // console.log('Main2 Scenairo Reset');
                SetStep(0);
            }
        }
    }, [isStart]);

    const scenarioStepRef = useRef(scenarioStep);

    useEffect(() => {
        //todo scenairoRef
        scenarioStepRef.current = scenarioStep;
    }, [scenarioStep]);

    useEffect(() => {
        if (!isStart)
            ShowTooltip();
    }, [lang]);

    useEffect(() => {
        SetMute(isMute);
    }, [isMute]);

    const navigationStyle = {
        bottom: isOpenAnimComplete ?
            (isOverlayContentVisible ?
                '-300px'
                : '0px')
            : '-300px',
        display: GetIsMobileDevice() ? 'none' : 'block',
    };
    // navigation info steps with step ranges
    const navigationInfoSteps = [
        {
            steps: [0, 1, 2, 3, 4, 5],
            title: 'Reasoning',
            desc: lang === 'ENG'
                ? 'We approach problems with logic, empathy, and curiosity.'
                : '우리는 논리, 공감, 그리고 호기심을 바탕으로 문제를 깊이 있게 이해합니다.'
        },
        {
            steps: [6, 7, 8],
            title: 'Conception',
            desc: lang === 'ENG'
                ? 'We turn insights into clear, actionable concepts.'
                : '발견한 인사이트를 명확하고 실행 가능한 개념으로 구체화합니다.'
        },
        {
            steps: [9, 10, 11, 12, 13, 14],
            title: 'Design',
            desc: lang === 'ENG'
                ? 'We design with intention-prioritizing clarity, usability, and interaction.'
                : '명확성, 사용성, 인터랙션을 우선순위에 두고 의도를 담은 디자인을 만듭니다.'
        },
        {
            steps: [15, 16, 17],
            title: 'Implementation',
            desc: lang === 'ENG'
                ? 'We build with care, bridging design and technology seamlessly.'
                : '디자인과 기술 사이의 경계를 자연스럽게 연결하며 정교하게 구현합니다.'
        }
    ];

    const navigationSteps = [
        {
            title: 'Onboarding',
            img:
                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="currentColor">
                    <g clipPath="url(#clip0_1297_10374)">
                        <path d="M11.8356 8.14781C7.0597 12.9238 7.6616 21.2689 13.1801 26.7874C18.6985 32.3057 27.0437 32.9077 31.8196 28.1319C31.8311 28.1204 31.8421 28.1082 31.8535 28.0966L31.8542 28.0973L28.7647 31.1868C28.721 31.232 28.6775 31.2782 28.6328 31.3228C28.5884 31.3672 28.5425 31.4105 28.4975 31.454L28.4416 31.51L28.4409 31.5093C23.636 36.0815 15.4387 35.4237 9.99325 29.9783C4.54782 24.5329 3.89002 16.3356 8.46233 11.5307L8.4575 11.5259L11.8701 8.11328L11.8708 8.11397C11.8593 8.12539 11.8471 8.13632 11.8356 8.14781Z" fill="currentColor" />
                        <path fillRule="evenodd" clipRule="evenodd" d="M31.4683 27.7784C36.0028 23.2439 35.4968 15.2186 30.1239 9.84567C24.751 4.47275 16.7257 3.96675 12.1912 8.50125C7.65671 13.0357 8.16271 21.061 13.5356 26.434C18.9085 31.8069 26.9338 32.3129 31.4683 27.7784ZM31.8219 28.1319C36.5979 23.3559 35.996 15.0106 30.4775 9.49211C24.959 3.97362 16.6136 3.37171 11.8377 8.1477C7.06167 12.9237 7.66358 21.269 13.1821 26.7875C18.7006 32.306 27.0459 32.9079 31.8219 28.1319ZM29.7053 26.0179C33.1886 22.5345 32.6648 16.1408 28.247 11.723C23.8293 7.30527 17.4355 6.78139 13.9521 10.2648C10.4687 13.7481 10.9926 20.1419 15.4104 24.5597C19.8281 28.9774 26.2219 29.5013 29.7053 26.0179ZM30.0588 26.3715C33.7988 22.6315 33.146 15.9148 28.6006 11.3695C24.0552 6.82408 17.3386 6.1712 13.5986 9.91121C9.85855 13.6512 10.5114 20.3678 15.0568 24.9132C19.6022 29.4586 26.3188 30.1115 30.0588 26.3715Z" fill="currentColor" />
                        <path fillRule="evenodd" clipRule="evenodd" d="M29.3512 25.6619C32.578 22.4352 32.1831 16.3642 27.893 12.0741C23.6029 7.78404 17.5319 7.38915 14.3052 10.6159C11.0784 13.8426 11.4733 19.9136 15.7634 24.2037C20.0535 28.4938 26.1245 28.8887 29.3512 25.6619ZM30.0583 26.369C33.7983 22.629 33.1454 15.9124 28.6001 11.367C24.0547 6.82166 17.3381 6.16878 13.5981 9.90878C9.85805 13.6488 10.5109 20.3654 15.0563 24.9108C19.6017 29.4562 26.3183 30.1091 30.0583 26.369Z" fill="currentColor" />
                        <path fillRule="evenodd" clipRule="evenodd" d="M22.9802 12.2175C22.445 11.9966 21.8901 11.8648 21.3356 11.8374C19.3775 11.7133 17.8616 12.8759 17.8516 15.0142C17.8475 15.269 17.8663 15.5299 17.9083 15.8003C18.0319 16.6347 18.3447 17.385 18.7967 18.0212C19.7012 19.398 21.1413 20.4471 22.6442 20.7791C21.9257 22.2092 20.6782 23.2248 18.2134 23.5104C18.1746 23.5168 18.1531 23.5548 18.1645 23.6016C18.1758 23.645 18.2162 23.6828 18.2555 23.69C23.3316 24.6125 27.3118 22.7771 27.1549 18.2847C27.065 15.7089 25.4466 13.1914 22.9802 12.2175Z" fill="currentColor" />
                    </g>
                    <defs>
                        <clipPath id="clip0_1297_10374">
                            <rect width="40" height="40" fill="currentColor" />
                        </clipPath>
                    </defs>
                </svg>
        },
        {
            title: 'Kick-Off',
            img:
                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="currentColor">
                    <path d="M35.6777 30.9678C35.6777 31.5201 35.23 31.9678 34.6777 31.9678H5.32031C4.76803 31.9678 4.32031 31.5201 4.32031 30.9678V25.7119H35.6777V30.9678ZM10.3945 16.2822H10.4072C10.6546 19.0493 14.8007 21.251 19.8799 21.251C24.9589 21.2509 29.1052 19.0493 29.3525 16.2822H29.3643V12.6191H33.6406C34.1588 12.6191 34.5911 13.0151 34.6367 13.5312L35.624 24.7119H4.37402L5.36133 13.5312C5.4069 13.0151 5.83922 12.6191 6.35742 12.6191H10.3945V16.2822ZM29.0234 12.6191C27.9208 14.8337 24.2461 16.4608 19.8799 16.4609C15.5135 16.4609 11.8381 14.8338 10.7354 12.6191H29.0234Z" fill="currentColor" />
                    <path d="M19.8795 5.99991C25.1179 5.99991 29.3644 8.34169 29.3644 11.2304C29.3644 14.1192 25.1179 16.4609 19.8795 16.4609C14.6411 16.4609 10.3945 14.1192 10.3945 11.2304C10.3945 8.34169 14.6411 5.99991 19.8795 5.99991Z" fill="currentColor" />
                </svg>
        },
        {
            title: 'Ideation',
            img:
                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="currentColor">
                    <path d="M24.1025 33.0439C24.1025 35.3184 22.2588 37.1638 19.9844 37.1641C17.7097 37.1641 15.8653 35.3186 15.8652 33.0439C15.8652 33.0241 15.8659 33.0042 15.8662 32.9844H24.1016C24.1018 33.0042 24.1025 33.0241 24.1025 33.0439ZM19.0488 24.1084H18.0488V24.1055H19.0488V24.1084ZM21.9199 24.1084H20.9199V24.1055H21.9199V24.1084ZM19.9844 2.5C26.3266 2.50014 31.4675 7.48394 31.4678 13.6318C31.4678 16.8638 30.0458 19.7725 27.7764 21.8057C27.0242 22.4796 26.3252 23.2298 25.8408 24.1055H21.9199V18.792H23.5732C25.0385 18.7919 26.2265 17.6039 26.2266 16.1387C26.2266 14.6734 25.0385 13.4855 23.5732 13.4854C22.1079 13.4854 20.9199 14.6733 20.9199 16.1387V17.792H19.0488V16.1387C19.0488 14.6733 17.8608 13.4854 16.3955 13.4854C14.9301 13.4854 13.7422 14.6733 13.7422 16.1387C13.7422 17.604 14.9302 18.792 16.3955 18.792H18.0488V24.1055H14.1104C13.6318 23.2261 12.9346 22.473 12.1826 21.7979C9.91829 19.765 8.5 16.8596 8.5 13.6318C8.50023 7.48385 13.642 2.5 19.9844 2.5ZM20.9199 18.792V24.1055H19.0488V18.792H20.9199ZM16.3955 14.4854C17.3086 14.4854 18.0488 15.2256 18.0488 16.1387V17.792H16.3955C15.4824 17.792 14.7422 17.0517 14.7422 16.1387C14.7422 15.2256 15.4824 14.4854 16.3955 14.4854ZM23.5732 14.4854C24.4862 14.4855 25.2266 15.2257 25.2266 16.1387C25.2265 17.0517 24.4862 17.7919 23.5732 17.792H21.9199V16.1387C21.9199 15.2256 22.6602 14.4854 23.5732 14.4854Z" fill="currentColor" />
                    <path d="M12.5957 26.0439C12.5957 25.4917 13.0434 25.0439 13.5957 25.0439H26.3722C26.9245 25.0439 27.3722 25.4917 27.3722 26.0439V31.0918C27.3722 31.6441 26.9245 32.0918 26.3722 32.0918H13.5957C13.0434 32.0918 12.5957 31.6441 12.5957 31.0918V26.0439Z" fill="currentColor" />
                </svg>
        },
        {
            title: 'Research',
            img:
                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="currentColor">
                    <path fillRule="evenodd" clipRule="evenodd" d="M20.7491 26.4319L25.9951 34.6258L24.7319 35.4346L19.9991 28.0424L15.2662 35.4346L14.0029 34.6258L19.2491 26.4319V20.3086H20.7491V26.4319Z" fill="currentColor" />
                    <path d="M25.4633 19.4822L11.8285 24.8259C11.5714 24.9266 11.2813 24.7999 11.1805 24.5428L8.11065 16.7098C8.01002 16.4527 8.13669 16.1626 8.39373 16.0618L22.0285 10.7181L25.4633 19.4822ZM9.93366 24.5301L7.73242 25.3928C7.47546 25.4935 7.18536 25.3665 7.08444 25.1097L4.75862 19.1752C4.65794 18.9181 4.78463 18.6279 5.04169 18.5272L7.24294 17.6645L9.93366 24.5301ZM5.8245 24.5043L5.54992 24.6119C5.03585 24.8133 4.45565 24.5596 4.25397 24.0457L3.40482 21.879C3.20347 21.3649 3.45685 20.7846 3.97097 20.5831L4.24556 20.4755L5.8245 24.5043Z" fill="currentColor" />
                    <path d="M34.6813 15.5342C35.4966 15.2146 36.1203 14.5041 36.415 13.5591C36.7097 12.614 36.6514 11.5117 36.2528 10.4947C35.8542 9.47773 35.1481 8.62933 34.2897 8.13618C33.4313 7.64302 32.491 7.54549 31.6756 7.86504L33.1785 11.6996L34.6813 15.5342Z" fill="currentColor" />
                    <path d="M23.7769 9.94014L29.305 6.47274L33.7244 17.7492L27.3124 18.9613L23.7769 9.94014Z" fill="currentColor" />
                    <path fillRule="evenodd" clipRule="evenodd" d="M29.5392 5.76029C29.7513 5.83022 29.9212 5.991 30.0026 6.19889L34.422 17.4753C34.5035 17.6832 34.4881 17.9166 34.38 18.112C34.272 18.3074 34.0824 18.4444 33.863 18.4859L27.451 19.698C27.0968 19.765 26.745 19.5704 26.6134 19.2348L23.0779 10.2136C22.9464 9.87795 23.0723 9.49617 23.3777 9.3046L28.9058 5.8372C29.095 5.71855 29.3272 5.69036 29.5392 5.76029ZM24.7013 10.245L27.7832 18.1087L32.6952 17.1801L28.9363 7.58876L24.7013 10.245Z" fill="currentColor" />
                </svg>
        },
        {
            title: 'Concept',
            img:
                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="currentColor">
                    <path d="M19.7773 6.7959C22.5596 6.7959 25.1457 7.63477 27.2979 9.07227L27.1484 9.83887L26.5547 12.8809C24.7638 11.2557 22.3861 10.2656 19.7773 10.2656C14.2065 10.2658 9.69043 14.7816 9.69043 20.3525C9.69043 25.9235 14.2065 30.4393 19.7773 30.4395C25.3484 30.4395 29.8652 25.9236 29.8652 20.3525C29.8652 19.6917 29.7991 19.0463 29.6777 18.4209L32.7012 19.46L33.3174 19.6709C33.3286 19.8967 33.335 20.1239 33.335 20.3525C33.335 27.8399 27.2647 33.9092 19.7773 33.9092C12.2902 33.909 6.2207 27.8397 6.2207 20.3525C6.2207 12.8653 12.2902 6.7961 19.7773 6.7959ZM19.7773 13.4678C21.3796 13.4678 22.8527 14.0167 24.0225 14.9346L20.7402 16.8301C20.4334 16.7464 20.1107 16.7012 19.7773 16.7012C17.7607 16.7012 16.126 18.3359 16.126 20.3525C16.126 22.3692 17.7607 24.0038 19.7773 24.0039C21.3319 24.0039 22.6578 23.032 23.1846 21.6631L26.6289 19.6748C26.6507 19.8978 26.6621 20.1238 26.6621 20.3525C26.6621 24.155 23.5798 27.2373 19.7773 27.2373C15.975 27.2372 12.8926 24.1549 12.8926 20.3525C12.8926 16.5502 15.975 13.4678 19.7773 13.4678ZM33.9268 12.3389L38.126 13.7822L32.2334 17.1846L29.4111 16.2148L20.3457 21.4492C19.8203 21.7524 19.1482 21.5721 18.8447 21.0469C18.5414 20.5214 18.7216 19.8493 19.2471 19.5459L28.3145 14.3115L28.8848 11.3818L34.7773 7.98047L33.9268 12.3389Z" fill="currentColor" />
                </svg>
        },
        {
            title: 'Design',
            img:
                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="currentColor">
                    <path d="M19.999 7.98047C28.6171 7.98047 35.6035 13.2928 35.6035 19.8457C35.6035 21.4223 35.2029 25.8623 30.8018 25.8623C26.8006 25.8623 27.4466 21.2148 23.1992 23.1846C22.1854 23.655 21.4448 25.8417 22.6152 27.3398C23.3845 28.325 22.9224 31.4336 19.999 31.4336C11.381 31.4336 4.39462 26.3986 4.39453 19.8457C4.39453 13.2928 11.3809 7.98047 19.999 7.98047ZM12.7383 21.1406C11.6036 21.1409 10.6839 22.0607 10.6836 23.1953C10.6836 24.3302 11.6035 25.2507 12.7383 25.251C13.8733 25.251 14.7939 24.3304 14.7939 23.1953C14.7937 22.0605 13.8732 21.1406 12.7383 21.1406ZM30.7744 16.8955C29.2216 16.8957 27.9629 18.1542 27.9629 19.707C27.9629 21.2598 29.2216 22.5183 30.7744 22.5186C32.3274 22.5186 33.5869 21.26 33.5869 19.707C33.5869 18.154 32.3274 16.8955 30.7744 16.8955ZM10.4766 13.9766C9.32669 13.9766 8.39453 14.9087 8.39453 16.0586C8.39453 17.2085 9.32669 18.1406 10.4766 18.1406C11.6264 18.1406 12.5586 17.2085 12.5586 16.0586C12.5586 14.9087 11.6264 13.9766 10.4766 13.9766ZM25.4131 11.3516C24.1947 11.3516 23.207 12.3393 23.207 13.5576C23.2071 14.7759 24.1948 15.7637 25.4131 15.7637C26.6314 15.7636 27.6191 14.7759 27.6191 13.5576C27.6191 12.3393 26.6314 11.3516 25.4131 11.3516ZM17.5811 10.0605C16.2443 10.0605 15.1602 11.1447 15.1602 12.4814C15.1602 13.8182 16.2443 14.9023 17.5811 14.9023C18.9176 14.9021 20.001 13.818 20.001 12.4814C20.001 11.1449 18.9176 10.0608 17.5811 10.0605Z" fill="currentColor" />
                </svg>
        },
        {
            title: 'Implement',
            img:
                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="currentColor">
                    <path d="M33.001 9.47559C34.1055 9.47559 35.001 10.371 35.001 11.4756V28.4336C35.001 29.5382 34.1055 30.4336 33.001 30.4336H7C5.89543 30.4336 5 29.5382 5 28.4336V11.4756C5 10.371 5.89543 9.47559 7 9.47559H33.001ZM30.1582 17.668V21.7354H32.334V17.668H30.1582Z" fill="currentColor" />
                </svg>
        },
        {
            title: 'Detail',
            img:
                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="currentColor">
                    <path d="M16.8203 14.209H3.51562V12.709H16.8203V14.209ZM35.6523 14.209H21.8223V12.709H35.6523V14.209Z" fill="currentColor" />
                    <path d="M26.4832 29.9025L22.8311 18.6319C22.6047 17.9332 23.3607 17.3242 23.9952 17.6943L34.2293 23.663C34.9108 24.0605 34.6664 25.1002 33.8791 25.1523L29.8481 25.4192C29.5118 25.4415 29.2256 25.672 29.1322 25.9958L28.0129 29.8775C27.7943 30.6356 26.7264 30.653 26.4832 29.9025Z" fill="currentColor" />
                    <path d="M19.1221 10C21.1439 10 22.7831 11.6393 22.7832 13.6611C22.7832 15.683 21.144 17.3223 19.1221 17.3223C17.5439 17.3222 16.1988 16.3237 15.6846 14.9238C11.7432 16.1346 8.77868 19.3646 8.08789 23.3076H9.46777C9.96464 23.3078 10.3672 23.7111 10.3672 24.208V28.457C10.367 28.9538 9.9645 29.3562 9.46777 29.3564H4.90039C4.40348 29.3564 4.00023 28.9539 4 28.457V24.208C4 23.711 4.40333 23.3076 4.90039 23.3076H6.56836C7.28419 18.5844 10.8274 14.7633 15.4688 13.4268C15.5897 11.5143 17.1791 10.0001 19.1221 10ZM5.80078 27.5566H8.56738V25.1084H5.80078V27.5566ZM19.1221 11.8008C18.0945 11.8009 17.2619 12.6335 17.2617 13.6611C17.2617 14.6888 18.0944 15.5223 19.1221 15.5225C20.1499 15.5225 20.9834 14.6889 20.9834 13.6611C20.9833 12.6334 20.1498 11.8008 19.1221 11.8008Z" fill="currentColor" />
                </svg>
        },
        {
            title: 'Delivery',
            img:
                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="currentColor">
                    <path d="M19.6211 6.71155C19.9044 6.59545 20.2283 6.61429 20.498 6.76916L31.3633 13.0094L31.3652 13.0104L31.3662 13.0114C31.6748 13.1901 31.8652 13.5199 31.8652 13.8766V26.3571C31.8651 26.715 31.6736 27.046 31.3633 27.2243L20.498 33.4645C20.4896 33.4693 20.4802 33.4726 20.4717 33.4772C20.4438 33.4921 20.4156 33.5061 20.3867 33.5182C20.3717 33.5245 20.3561 33.5293 20.3408 33.5348C20.3178 33.5432 20.2949 33.5516 20.2715 33.5583C20.2528 33.5635 20.2338 33.5678 20.2148 33.5719C20.1954 33.5762 20.1759 33.5796 20.1562 33.5827C20.1367 33.5858 20.1173 33.5886 20.0977 33.5905C20.0729 33.5929 20.0483 33.5948 20.0234 33.5954C20.0088 33.5957 19.9942 33.5957 19.9795 33.5954C19.9511 33.5948 19.9228 33.5925 19.8945 33.5895C19.8825 33.5882 19.8704 33.5873 19.8584 33.5856C19.8217 33.5804 19.7851 33.5735 19.749 33.5641C19.7462 33.5634 19.7431 33.5629 19.7402 33.5622C19.7001 33.5514 19.66 33.539 19.6211 33.5231L19.502 33.4645L8.63672 27.2243C8.32638 27.046 8.1349 26.715 8.13477 26.3571V13.8766L8.14355 13.7448C8.14913 13.7029 8.15727 13.6612 8.16797 13.6207C8.17081 13.61 8.17453 13.5991 8.17773 13.5885C8.18607 13.5609 8.1954 13.5332 8.20605 13.5065C8.21223 13.491 8.21963 13.4757 8.22656 13.4606C8.23636 13.4392 8.24655 13.4177 8.25781 13.3971C8.26653 13.3812 8.27656 13.3657 8.28613 13.3502C8.29884 13.3297 8.312 13.3092 8.32617 13.2897C8.3343 13.2785 8.34297 13.2673 8.35156 13.2565C8.36883 13.2347 8.38715 13.2134 8.40625 13.193C8.41689 13.1817 8.42729 13.1697 8.43848 13.1588C8.49649 13.1025 8.56208 13.0529 8.63379 13.0114V13.0104L8.63672 13.0094L19.502 6.76916L19.6211 6.71155ZM30.3545 14.441C30.1454 14.0837 29.6856 13.9635 29.3281 14.1725L20.0889 19.5748L10.6582 14.1696C10.2989 13.9636 9.84078 14.0877 9.63477 14.4469C9.42883 14.8062 9.55288 15.2643 9.91211 15.4703L19.3428 20.8756V31.4889C19.3428 31.9031 19.6787 32.2388 20.0928 32.2389C20.507 32.2389 20.8428 31.9031 20.8428 31.4889V20.8717L30.0859 15.4674C30.4434 15.2583 30.5635 14.7986 30.3545 14.441Z" fill="currentColor" />
                </svg>
        },
    ];

    const navigationDotSteps = [
        { steps: [0] },
        { steps: [1] },
        { steps: [2, 3] },
        { steps: [4, 5] },
        { steps: [6, 7] },
        { steps: [8, 9, 10] },
        { steps: [11, 12, 13] },
        { steps: [14, 15, 16, 17] },
        { steps: [18, 19] },
    ];

    // navigationStatesRef for navigation items
    const navigationStatesRef = useRef(new Array(navigationSteps.length).fill(''));

    useEffect(() => {
        SetNavigationStateRef(navigationStatesRef);
    }, []);

    const getStateForStep = (currentStep, steps) => {
        if (currentStep > Math.max(...steps)) return 'complete';
        if (steps.includes(currentStep)) return 'active';
        return '';
    };

    //#region controlls
    const controlsRef = useRef(null);
    let isUseControl = false;
    const Controls = () => {
        isUseControl = true;
        if (controlsRef.current) {
            controlsRef.current.dispose(); // ✅ 기존 컨트롤 제거
        }

        controlsRef.current = new OrbitControls(camera, canvasRef.current);
        controlsRef.current.target.set(0, -0.05, -0.4);
        controlsRef.current.update();
    };
    //#endregion

    const Init = async () => {
        //#region settings
        sizes = {
            width: window.innerWidth,
            height: window.innerHeight
        }

        SetupScene();
        const lightSetup = SetupLights();
        light = lightSetup.light;
        camera = SetupCamera(scene, sizes);
        const rendererSetup = setupRenderer(canvasRef.current, sizes);
        renderer = rendererSetup.renderer;
        pmremGenerator = rendererSetup.pmremGenerator;

        loadingManager = setLoadingManager(
            loadingRef,
            loadingAnimationLoopRef
        );
        try {
            const modelSetup = await loadModel(
                scene,
                group,
                loadingManager,
                SetLoading,
                loadingRef,
                loadingRateRef,
                pmremGenerator
            );
            gltf = modelSetup.gltf;
            obj = modelSetup.obj;
            // mixer = modelSetup.mixer;
            // animations = modelSetup.animations;

            // console.log("✅ Model loaded successfully:", obj);
            // console.log("Animations: ", animations);
        } catch (error) {
            console.error("❌ Error loading model:", error);
        }

        ///* model 로딩 완료.

        // invokeAfterDelay(() => {
        //     const logo = document.querySelector('.home_logo-box');
        //     const info = document.querySelector('.home_info-box');

        //     logo.style.transition = 'opacity 0.3s ease-out';
        //     info.style.transition = 'opacity 0.3s ease-out';
        // }, 3);
        // 모델 로드 완료 후 카메라 애니메이션 호출
        invokeAfterDelay(() => {
            setIsModelLoaded(true);
            AnimateCamera(
                camera.position,
                // { x: -0.13493567705154408, y: 1.4965717792510977, z: 2.643615722656248 },
                { x: -0.1349356770515442, y: 1.5091348886489868, z: 2.64361572265625 },
                { x: -0.009703266434371471, y: 0.21662688255310059, z: 0.13180576264858246 },
                2,
                'power2-inOut',
                () => {
                    setIsOpenAnimComplete(true)
                }
            )
            blurRef.current.style.opacity = 0;
        }, 1)
        //#endregion

        coin = group.getObjectByName('start_coin');
        objet = group.getObjectByName('objet');

        // 모바일 장치에서는 동전을 숨김
        if (GetIsMobileDevice()) {
            coin.visible = false;

            const home = document.querySelector('.home-container');
            const mobileHome = document.querySelector('.home-mobile-noti');
            home.style.display = 'none';
            mobileHome.style.display = 'block';
        }


        //#region * interactive
        //* audio
        // listener = SetAudioListener(camera);
        // SetBGM();

        SetStepChangeListener(setScenarioStep);
        InitScenario();
        SetStageRaycastList(scene, 0);

        let camNull = null;
        let aimNull = null;
        invokeAfterDelay(() => {
            camNull = obj.getObjectByName('null_cam');
            aimNull = obj.getObjectByName('null_aim');
        }, 5);

        //idle animations
        SetAnimations(gltf, obj);

        Update(scene, camera, renderer, () => {
            const delta = clock.getDelta();
            UpdateMixers(delta);
            if (camera) UpdateRaycaster(camera);
            if (!isUseControl) {
                if (camNull && aimNull) {
                    camera.position.lerp(camNull.position, 0.1);
                    camera.lookAt(aimNull.position);
                    camera.updateProjectionMatrix();
                }
            }
            if (coin) {
                const coinWorldPos = new THREE.Vector3();
                coin.getWorldPosition(coinWorldPos);

                camera.updateMatrixWorld();
                const projected = coinWorldPos.clone().project(camera);
                const x = (projected.x + 1) / 2 * window.innerWidth;
                const y = (-projected.y + 1) / 2 * window.innerHeight;
                setCoinScreenPos({ x, y });
            }

            if (scenarioStepRef.current === 21) {
                // console.log('!!!!!!!!');
                objet.rotation.x = THREE.MathUtils.lerp(objet.rotation.x, mouseY * Math.PI, 0.1);
                objet.rotation.y = THREE.MathUtils.lerp(objet.rotation.y, mouseX * Math.PI, 0.1);
            }
            // console.lo.position);
        });

        //#endregion

        // Controls();

        return () => {
            if (pmremGenerator) {
                pmremGenerator.dispose();
                pmremGenerator = null;
            }
        }
    }


    return (
        <>
            <div className="main">
                <canvas
                    ref={canvasRef}
                    className='webgl'></canvas>
                <div
                    ref={blurRef}
                    className="webgl-blur"></div>
                <div
                    ref={balloonRef}
                    className="balloon-event">
                    <div
                        ref={cloundContainerRef}
                        className="cloud-container"></div>
                    <div
                        ref={balloonCrosshairBgRef}
                        className="balloon-event_crosshair-bg">
                        <svg xmlns="http://www.w3.org/2000/svg" width="1920" height="1081" viewBox="0 0 1920 1081" fill="none">
                            <g filter="url(#filter0_f_1225_61884)">
                                <path d="M4210 3324H-2290V-2244H4210V3324ZM960 -107.96C602.119 -107.96 312 182.16 312 540.04C312 897.921 602.119 1188.04 960 1188.04C1317.88 1188.04 1608 897.921 1608 540.04C1608 182.16 1317.88 -107.96 960 -107.96Z" fill="#262626" fillOpacity="0.95" />
                            </g>
                            <defs>
                                <filter id="filter0_f_1225_61884" x="-2410" y="-2364" width="6740" height="5808" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                                    <feGaussianBlur stdDeviation="60" result="effect1_foregroundBlur_1225_61884" />
                                </filter>
                            </defs>
                        </svg>
                    </div>
                    <div
                        ref={balloonCrosshairRef}
                        className="balloon-event_crosshair"
                    >
                        <div className="crosshair_point"></div>
                        <div className="crosshair_circle"></div>
                        {/* <img src={process.env.PUBLIC_URL + "/data/img/crosshair.png"} alt="" /> */}
                    </div>
                    <div
                        ref={balloonDimRef}
                        className="balloon-event_dim"></div>
                </div>
                <div
                    style={navigationStyle}
                    className="main_navigation">
                    <div
                        className="navigation_bg"></div>
                    <div
                        className="navigation_info-container">
                        {(() => {
                            const currentInfo = navigationInfoSteps.find(item => item.steps.includes(scenarioStepRef.current));
                            return (
                                <>
                                    <div className="navigation_info-title">{currentInfo?.title}</div>
                                    <div className="navigation_info-desc">{currentInfo?.desc}</div>
                                </>
                            );
                        })()}
                    </div>
                    <div className="navigation_item-container">
                        {navigationSteps.map((item, idx) => {
                            const dotState = idx < navigationDotSteps.length - 1
                                ? getStateForStep(scenarioStepRef.current, navigationDotSteps[idx + 1].steps)
                                : '';

                            return (
                                <Fragment key={idx}>
                                    <MainNavigationItem
                                        state={navigationStatesRef.current[idx]}
                                        title={item.title}
                                        img={item.img}
                                    />
                                    {idx < navigationDotSteps.length - 1 && (
                                        <MainNavigationDotItem state={dotState} />
                                    )}
                                </Fragment>
                            );
                        })}
                    </div>
                </div>
            </div>
            <div ref={loadingRef} className="loading">
                <div className="loading-container">
                    <div className="loading-animation">
                        <video
                            ref={loadingAnimationLoopRef}
                            className='loading-animation_loop'
                            playsInline
                            muted
                            autoPlay
                            preload="auto"
                            loop
                            type='video/webm'
                        >
                            <source
                                src={process.env.PUBLIC_URL + "/data/loading/loading_motion.mp4"}
                                type='video/mp4' />
                            <source
                                src={process.env.PUBLIC_URL + "/data/loading/loading_motion.webm"}
                                type='video/webm' />
                        </video>
                    </div>
                    <div
                        ref={loadingRateRef}
                        className="loading-rate">0
                    </div>
                    {/* <div className="loading-logo-bg">
                        <svg width="828" height="120" viewBox="0 0 828 120" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                            <path fillRule="evenodd" clipRule="evenodd" d="M646.602 35.7617V110H664.102V35.7617H646.602ZM645.371 15.6641C645.371 20.9961 650.02 25.2344 655.488 25.2344C661.094 25.2344 665.605 20.9961 665.605 15.6641C665.605 10.4688 661.094 6.23047 655.488 6.23047C650.02 6.23047 645.371 10.4688 645.371 15.6641ZM713.184 111.504C691.582 111.504 677.637 96.1914 677.637 73.2227C677.637 50.1172 691.582 34.8047 713.184 34.8047C734.922 34.8047 748.73 50.1172 748.73 73.2227C748.73 96.1914 734.922 111.504 713.184 111.504ZM713.32 97.5586C725.215 97.5586 731.094 86.7578 731.094 73.0859C731.094 59.5508 725.215 48.6133 713.32 48.6133C701.152 48.6133 695.273 59.5508 695.273 73.0859C695.273 86.7578 701.152 97.5586 713.32 97.5586ZM779.766 66.5234V110H762.266V35.7617H778.945V48.3398H779.902C783.32 40 790.84 34.8047 801.914 34.8047C817.363 34.8047 827.48 44.9219 827.344 62.6953V110H809.98V65.4297C809.98 55.4492 804.648 49.5703 795.488 49.5703C786.191 49.5703 779.766 55.7227 779.766 66.5234ZM633.203 35.7617V49.1602H618.574V87.7148C618.574 94.8242 622.129 96.3281 626.504 96.3281C628.555 96.3281 631.973 96.1914 634.16 96.0547V110.273C632.109 110.684 628.691 110.957 624.316 110.957C611.191 110.957 601.074 104.531 601.211 90.5859V49.1602H590.547V35.7617H601.211V17.9883H618.574V35.7617H633.203ZM515.625 73.2227C515.625 95.6445 529.023 111.504 551.172 111.504C569.766 111.504 581.66 100.43 583.027 84.707H566.348C564.844 92.7734 559.102 97.2852 551.309 97.2852C540.371 97.2852 533.262 88.125 533.262 72.8125C533.262 57.9102 540.508 48.75 551.309 48.75C559.785 48.75 564.98 54.2188 566.348 61.3281H583.027C581.797 45.332 569.219 34.8047 551.172 34.8047C529.434 34.8047 515.625 50.5273 515.625 73.2227ZM438.379 89.082C438.379 72.4023 452.188 67.4805 465.996 66.6602C471.123 66.3184 481.787 65.7031 485 65.5664V59.6875C485 52.3047 480.215 48.0664 471.602 48.0664C463.809 48.0664 459.023 51.6211 457.656 56.9531H440.84C442.07 44.375 453.418 34.8047 472.012 34.8047C486.094 34.8047 502.363 40.5469 502.363 60.3711V110H485.684V99.7461H485.137C481.855 106.035 474.883 111.504 463.262 111.504C449.043 111.504 438.379 103.711 438.379 89.082ZM455.195 88.9453C455.195 95.3711 460.391 98.6523 467.773 98.6523C478.301 98.6523 485.137 91.6797 485.137 83.3398V77.1875L468.73 78.2812C460.391 78.9648 455.195 82.3828 455.195 88.9453ZM390.391 35.7617V110H407.891V66.25C407.891 56.8164 415 50.1172 424.707 50.1172C427.578 50.1172 431.27 50.6641 432.773 51.2109V35.0781C431.133 34.8047 428.398 34.668 426.484 34.668C418.008 34.668 410.762 39.5898 408.164 48.0664H407.344V35.7617H390.391ZM343.906 111.504C321.484 111.504 307.812 96.6016 307.812 73.3594C307.812 50.3906 321.758 34.8047 342.949 34.8047C361.133 34.8047 376.855 46.1523 376.855 72.2656V77.7344H325.039C325.244 90.3809 332.695 97.832 344.043 97.832C351.699 97.832 356.895 94.5508 359.082 90.1758H376.172C373.027 103.027 361.133 111.504 343.906 111.504ZM325.176 65.8398H360.176C360.039 55.7227 353.34 48.3398 343.223 48.3398C332.695 48.3398 325.723 56.3379 325.176 65.8398ZM298.379 49.1602V35.7617H283.75V17.9883H266.387V35.7617H255.723V49.1602H266.387V90.5859C266.25 104.531 276.367 110.957 289.492 110.957C293.867 110.957 297.285 110.684 299.336 110.273V96.0547C297.148 96.1914 293.73 96.3281 291.68 96.3281C287.305 96.3281 283.75 94.8242 283.75 87.7148V49.1602H298.379ZM197.07 66.5234V110H179.57V35.7617H196.25V48.3398H197.207C200.625 40 208.145 34.8047 219.219 34.8047C234.668 34.8047 244.785 44.9219 244.648 62.6953V110H227.285V65.4297C227.285 55.4492 221.953 49.5703 212.793 49.5703C203.496 49.5703 197.07 55.7227 197.07 66.5234ZM161.934 110V11.0156H144.16V110H161.934Z" fill="currentColor" />
                            <path fillRule="evenodd" clipRule="evenodd" d="M53.6591 99.7916C53.7148 99.5369 53.7347 99.2782 53.7347 99.0176L53.7367 99.0216L53.6849 61.98C53.6849 50.8279 49.043 47.2645 40.8416 47.2645C35.1154 47.2645 30.3183 49.5864 27.0692 51.9103L27.0433 98.8902C27.0433 99.1509 27.0632 99.4115 27.1189 99.6642C27.2801 100.39 27.6641 101.035 28.1953 101.521C29.7373 102.79 33.0203 103.906 35.1054 104.525C35.3959 104.611 35.3342 105.04 35.0298 105.04H19.6099H2.01728C1.71485 105.04 1.65118 104.615 1.93968 104.525L1.97152 104.515C3.80599 103.94 6.57362 102.925 8.12158 101.65C8.68266 101.139 9.0806 100.45 9.22385 99.6722C9.26364 99.4573 9.27359 99.2384 9.27359 99.0216V18.9157C9.27359 13.3387 8.34442 11.9459 4.32131 10.7064L0.198724 9.28776C-0.0678911 9.19424 -0.0659015 8.81621 0.202703 8.72866L26.7528 0.0179171C26.9856 -0.0576901 27.2244 0.115411 27.2244 0.360139V48.3448L27.5347 48.5C34.807 42.4594 43.7824 35.4896 53.6849 35.4896C58.6372 35.4896 62.8155 37.1928 66.2198 40.4459C69.9325 44.3178 71.3253 50.6688 71.3253 57.7938L71.5044 98.8883C71.5044 99.1489 71.5243 99.4095 71.58 99.6622C71.7412 100.388 72.1252 101.033 72.6564 101.519C74.1984 102.788 77.4813 103.904 79.5665 104.523C79.857 104.609 79.7953 105.038 79.4909 105.038H46.4784C46.1759 105.038 46.1123 104.613 46.4008 104.523L46.4326 104.513C48.2671 103.938 51.0347 102.923 52.5827 101.648C53.1139 101.164 53.4979 100.52 53.6591 99.7916ZM96.3725 75.2867C98.3503 74.8679 100.316 74.8097 102.201 75.0773C110.892 76.1592 116.36 83.3607 116.36 92.1794C116.36 107.56 101.91 117.588 83.8891 119.101C83.7495 119.112 83.6099 119.019 83.575 118.88C83.5401 118.728 83.6215 118.577 83.7611 118.519C92.603 115.25 97.1869 110.584 99.9325 104.977C94.6041 105.221 89.5898 102.929 86.5301 99.0086C84.9944 97.2285 83.9706 94.925 83.6332 92.1561C83.5168 91.2603 83.4819 90.3761 83.5285 89.4919C83.8309 82.0926 89.392 76.6712 96.3725 75.2867Z" fill="currentColor" />
                        </svg>
                    </div> */}
                    <div className="loading-logo">
                        <svg width="828" height="120" viewBox="0 0 828 120" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                            <path fillRule="evenodd" clipRule="evenodd" d="M646.602 35.7617V110H664.102V35.7617H646.602ZM645.371 15.6641C645.371 20.9961 650.02 25.2344 655.488 25.2344C661.094 25.2344 665.605 20.9961 665.605 15.6641C665.605 10.4688 661.094 6.23047 655.488 6.23047C650.02 6.23047 645.371 10.4688 645.371 15.6641ZM713.184 111.504C691.582 111.504 677.637 96.1914 677.637 73.2227C677.637 50.1172 691.582 34.8047 713.184 34.8047C734.922 34.8047 748.73 50.1172 748.73 73.2227C748.73 96.1914 734.922 111.504 713.184 111.504ZM713.32 97.5586C725.215 97.5586 731.094 86.7578 731.094 73.0859C731.094 59.5508 725.215 48.6133 713.32 48.6133C701.152 48.6133 695.273 59.5508 695.273 73.0859C695.273 86.7578 701.152 97.5586 713.32 97.5586ZM779.766 66.5234V110H762.266V35.7617H778.945V48.3398H779.902C783.32 40 790.84 34.8047 801.914 34.8047C817.363 34.8047 827.48 44.9219 827.344 62.6953V110H809.98V65.4297C809.98 55.4492 804.648 49.5703 795.488 49.5703C786.191 49.5703 779.766 55.7227 779.766 66.5234ZM633.203 35.7617V49.1602H618.574V87.7148C618.574 94.8242 622.129 96.3281 626.504 96.3281C628.555 96.3281 631.973 96.1914 634.16 96.0547V110.273C632.109 110.684 628.691 110.957 624.316 110.957C611.191 110.957 601.074 104.531 601.211 90.5859V49.1602H590.547V35.7617H601.211V17.9883H618.574V35.7617H633.203ZM515.625 73.2227C515.625 95.6445 529.023 111.504 551.172 111.504C569.766 111.504 581.66 100.43 583.027 84.707H566.348C564.844 92.7734 559.102 97.2852 551.309 97.2852C540.371 97.2852 533.262 88.125 533.262 72.8125C533.262 57.9102 540.508 48.75 551.309 48.75C559.785 48.75 564.98 54.2188 566.348 61.3281H583.027C581.797 45.332 569.219 34.8047 551.172 34.8047C529.434 34.8047 515.625 50.5273 515.625 73.2227ZM438.379 89.082C438.379 72.4023 452.188 67.4805 465.996 66.6602C471.123 66.3184 481.787 65.7031 485 65.5664V59.6875C485 52.3047 480.215 48.0664 471.602 48.0664C463.809 48.0664 459.023 51.6211 457.656 56.9531H440.84C442.07 44.375 453.418 34.8047 472.012 34.8047C486.094 34.8047 502.363 40.5469 502.363 60.3711V110H485.684V99.7461H485.137C481.855 106.035 474.883 111.504 463.262 111.504C449.043 111.504 438.379 103.711 438.379 89.082ZM455.195 88.9453C455.195 95.3711 460.391 98.6523 467.773 98.6523C478.301 98.6523 485.137 91.6797 485.137 83.3398V77.1875L468.73 78.2812C460.391 78.9648 455.195 82.3828 455.195 88.9453ZM390.391 35.7617V110H407.891V66.25C407.891 56.8164 415 50.1172 424.707 50.1172C427.578 50.1172 431.27 50.6641 432.773 51.2109V35.0781C431.133 34.8047 428.398 34.668 426.484 34.668C418.008 34.668 410.762 39.5898 408.164 48.0664H407.344V35.7617H390.391ZM343.906 111.504C321.484 111.504 307.812 96.6016 307.812 73.3594C307.812 50.3906 321.758 34.8047 342.949 34.8047C361.133 34.8047 376.855 46.1523 376.855 72.2656V77.7344H325.039C325.244 90.3809 332.695 97.832 344.043 97.832C351.699 97.832 356.895 94.5508 359.082 90.1758H376.172C373.027 103.027 361.133 111.504 343.906 111.504ZM325.176 65.8398H360.176C360.039 55.7227 353.34 48.3398 343.223 48.3398C332.695 48.3398 325.723 56.3379 325.176 65.8398ZM298.379 49.1602V35.7617H283.75V17.9883H266.387V35.7617H255.723V49.1602H266.387V90.5859C266.25 104.531 276.367 110.957 289.492 110.957C293.867 110.957 297.285 110.684 299.336 110.273V96.0547C297.148 96.1914 293.73 96.3281 291.68 96.3281C287.305 96.3281 283.75 94.8242 283.75 87.7148V49.1602H298.379ZM197.07 66.5234V110H179.57V35.7617H196.25V48.3398H197.207C200.625 40 208.145 34.8047 219.219 34.8047C234.668 34.8047 244.785 44.9219 244.648 62.6953V110H227.285V65.4297C227.285 55.4492 221.953 49.5703 212.793 49.5703C203.496 49.5703 197.07 55.7227 197.07 66.5234ZM161.934 110V11.0156H144.16V110H161.934Z" fill="currentColor" />
                            <path fillRule="evenodd" clipRule="evenodd" d="M53.6591 99.7916C53.7148 99.5369 53.7347 99.2782 53.7347 99.0176L53.7367 99.0216L53.6849 61.98C53.6849 50.8279 49.043 47.2645 40.8416 47.2645C35.1154 47.2645 30.3183 49.5864 27.0692 51.9103L27.0433 98.8902C27.0433 99.1509 27.0632 99.4115 27.1189 99.6642C27.2801 100.39 27.6641 101.035 28.1953 101.521C29.7373 102.79 33.0203 103.906 35.1054 104.525C35.3959 104.611 35.3342 105.04 35.0298 105.04H19.6099H2.01728C1.71485 105.04 1.65118 104.615 1.93968 104.525L1.97152 104.515C3.80599 103.94 6.57362 102.925 8.12158 101.65C8.68266 101.139 9.0806 100.45 9.22385 99.6722C9.26364 99.4573 9.27359 99.2384 9.27359 99.0216V18.9157C9.27359 13.3387 8.34442 11.9459 4.32131 10.7064L0.198724 9.28776C-0.0678911 9.19424 -0.0659015 8.81621 0.202703 8.72866L26.7528 0.0179171C26.9856 -0.0576901 27.2244 0.115411 27.2244 0.360139V48.3448L27.5347 48.5C34.807 42.4594 43.7824 35.4896 53.6849 35.4896C58.6372 35.4896 62.8155 37.1928 66.2198 40.4459C69.9325 44.3178 71.3253 50.6688 71.3253 57.7938L71.5044 98.8883C71.5044 99.1489 71.5243 99.4095 71.58 99.6622C71.7412 100.388 72.1252 101.033 72.6564 101.519C74.1984 102.788 77.4813 103.904 79.5665 104.523C79.857 104.609 79.7953 105.038 79.4909 105.038H46.4784C46.1759 105.038 46.1123 104.613 46.4008 104.523L46.4326 104.513C48.2671 103.938 51.0347 102.923 52.5827 101.648C53.1139 101.164 53.4979 100.52 53.6591 99.7916ZM96.3725 75.2867C98.3503 74.8679 100.316 74.8097 102.201 75.0773C110.892 76.1592 116.36 83.3607 116.36 92.1794C116.36 107.56 101.91 117.588 83.8891 119.101C83.7495 119.112 83.6099 119.019 83.575 118.88C83.5401 118.728 83.6215 118.577 83.7611 118.519C92.603 115.25 97.1869 110.584 99.9325 104.977C94.6041 105.221 89.5898 102.929 86.5301 99.0086C84.9944 97.2285 83.9706 94.925 83.6332 92.1561C83.5168 91.2603 83.4819 90.3761 83.5285 89.4919C83.8309 82.0926 89.392 76.6712 96.3725 75.2867Z" fill="currentColor" />
                        </svg>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Main;
